import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default class SubStepTwoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textInput: '',
        };
    }

    // Email       string `json:"email,omitempty"`
    // PhoneNumber string `json:"phone,omitempty"`
    // Token       string `json:"to,omitempty"`
    // Id          string `json:"id,omitempty"`
    // OldToken    string `json:"oldid,omitempty"`

    subscribe = data => {
        fetch('https://services.skyharbor.com/tmf/requestUpdates', {
            headers: {
                'Content-Type': 'applicaton/json',
            },
            method: 'POST',
            body: data,
        }).then(() => {
            this.setState(Object.assign(this.state, {textInput: ''}));
            this.props.navigationFunc(true);
        });
    };

    validateEmail = email => {
        // eslint-disable-next-line no-useless-escape
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    alertOnInvalidEmail = email => {
        if (!this.validateEmail(email)) {
            alert('Please enter a valid e-mail address');
            return;
        }
        this.props.setUserInfo(email);
        this.subscribe(JSON.stringify({email, id: this.props.model.Topic, data:this.props.model}));
    };

    alertOnInvalidPhone = phone => {
        if (phone.length === 11) {
            this.subscribe(
                JSON.stringify({
                    id: this.props.model.Topic,
                    phone,
                    data:this.props.model
                })
            );
            return;
        }
        alert('Please enter a valid Phone Number');

    };

    handleInput = textInput => {
        if (this.props.notificationMethod === 1) {
            this.setState(
                Object.assign(this.state, {
                    textInput: textInput.target.value,
                }),
            );
            return;
        }
        let startString = textInput.target.value.replace(/\D/g, '');
        let result = '';
        for (let letter of startString) {
            console.log(result.length);
            result += letter;

            if (result.length === 3) {
                result += '-';
            }
            if (result.length === 7) {
                result += '-';
            }
            if (result.length > 11) {
                this.setState(Object.assign(this.state, {textInput: result}));
                return;
            }
        }
        this.setState(Object.assign(this.state, {textInput: result}));
    };

    render() {
        if (this.props.model === undefined) {
            return null;
        }
        return (
            <Modal
                show={this.props.isShowing}
                size={'lg'}
                centered
                onHide={this.props.close}>
                <Modal.Header>
                    <Modal.Title className='w-100 text-center'>
                        {this.props.notificationMethod === 0 ? '' : ''}
                        {this.props.notificationMethod === 1
                            ? 'Enter Email Address'
                            : ''}
                        {this.props.notificationMethod === 2
                            ? 'Enter Phone Number'
                            : ''}
                    </Modal.Title>
                    <button
                        type='button'
                        style={{}}
                        onClick={this.props.close}
                        className='close'>
                        <span aria-hidden='true'>×</span>
                        <span className='sr-only'>Close</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    {this.props.notificationMethod === 0 ? (
                        <div>
                            <div className={'col-12 text-center mb-2'}>
                                <h5>Thanks</h5>
                            </div>

                            <div className={'col-12'}>
                                We'll send you notifications
                            </div>
                        </div>
                    ) : null}
                    {this.props.notificationMethod === 1 ? (
                        <div>
                            <div className={'col-12 text-center mb-2'}>
                                <h5>Please provide an email address you want your flight notifications sent to :</h5>
                            </div>

                            <div className={'col-12'}>
                                <input
                                    className={'form-control'}
                                    type={'email'}
                                    value={this.state.textInput}
                                    onChange={this.handleInput}
                                />
                            </div>
                        </div>
                    ) : null}
                    {this.props.notificationMethod === 2 ? (
                        <div>
                            <div className={'col-12 text-center mb-2'}>
                                <h5>Please provide a 10 digit phone number</h5>
                                e.g. 555-555-5555
                            </div>
                            <div className={'col-12'}>
                                <input
                                    className={'form-control'}
                                    type={'tel'}
                                    value={this.state.textInput}
                                    onChange={this.handleInput}
                                />
                            </div>
                            <div className={'col-12'}>
                                <small style={{color: 'black'}}>
                                    Providing your mobile phone number indicates
                                    that you consent to receiving automated text
                                    messages regarding flight details from
                                    Phoenix Sky Harbor. Text messaging available
                                    only to U.S. mobile carriers. Message and
                                    Data Rates May Apply. Messaging frequency
                                    varies based on changes to the subscribed
                                    flight. You may opt out at any time by
                                    texting PHX STOP to 878787 from your mobile
                                    device.
                                </small>
                            </div>
                        </div>
                    ) : null}
                </Modal.Body>
                <Modal.Footer>
                    {/*<button*/}
                    {/*    onClick={() => this.props.navigationFunc(false)}*/}
                    {/*    className='btn btn-secondary flbtn btn-block'>*/}
                    {/*    Back*/}
                    {/*</button>*/}

                    <button
                        onClick={() => {
                            if (this.props.notificationMethod === 0) {
                                this.props.close();
                                return;
                            }
                            if (this.props.notificationMethod === 1) {
                                this.alertOnInvalidEmail(this.state.textInput);
                                return;
                            }
                            this.props.setUserInfo(this.state.textInput);
                            //validate 10 digit number here.

                            this.alertOnInvalidPhone('1' + this.state.textInput.replace(/\D/g, '',));

                        }}
                        className='btn btn-primary flbtn btn-block'>
                        Submit
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}
